import { NotFoundException } from "../customExceptions";
import Loader from "@material-ui/core/CircularProgress";
import trimString from "../helpers/trimString";
import { useGetAdAccount } from "../queries/adAccounts";
import { ENTITY } from "../constants";

export const AdAccountBreadcrumb = ({ match }) => {
  // Entity
  const { ADACCOUNT } = ENTITY;

    const {
      data: adAccount,
      isLoading,
      isError,
      error,
    } = useGetAdAccount(match.params.adAccountId);
  
    if (isLoading) {
      //return <span>Loading...</span>;
      return <Loader color="primary" size={18} sx={{ mr: 1 }} />;
    }
  
    if (isError && error instanceof NotFoundException) {
      return <span>Not found</span>;
    }
  
    if (adAccount) {
      return <span>{trimString(adAccount[ADACCOUNT.nameField], 20)}</span>;
    }
  
    return null;
  };